export default obj => {
  return JSON.parse(JSON.stringify(obj));
};
